module.exports = function(app) {
    app.factory('userUtil', ['$q', 'services','sessionData','dataManager',
        function($q, services,sessionData,dataManager) {

            var
                extractspaMemberData,
                extractHcraIndicator;

            //simplify member data
            extractspaMemberData = function (data) {
                var spaMemberData = {}, spaMemberDataTest = {};

                spaMemberData = data;
                spaMemberData.umi = data.umi + '0';
                return spaMemberData;
            };

                //extract the HCRA indicator by group to save time later
            extractHcraIndicator = function(data) {

                    var hcraIndicatorsByClient = {}
                    var clientLength = data.clientList.length;
                    for ( var i = 0; i < clientLength; ++i ) {

                        var groupLength = data.clientList[i].groupList.length;
                        for ( var j = 0; j < groupLength; ++j ) {

                            hcraIndicatorsByClient[data.clientList[i].clientNumber] = data.clientList[i].groupList[j].hcraIndicator;

                        }
                    }

                    return hcraIndicatorsByClient;

            };






            return {
                extractspaMemberData:extractspaMemberData,
                extractHcraIndicator: extractHcraIndicator

            };
        }
    ]);
};